// @flow @jsx h
/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/always-return */
/* eslint-disable compat/compat */

import { Component, h } from 'preact'
import { DisableScroll } from '../../../../lib/DisableScroll'

import styles from './index.css'

type Props = {
  viewport: { height: number },
  allowed: boolean,
  complete: boolean,
  onComplete: () => void
}

export class Logo extends Component<Props> {
  elm: HTMLElement
  animationElm: HTMLElement
  disableScroll: any
  animation: any
  animationStarted = false
  fadingOut = false

  componentDidMount () {
    this.disableScroll = new DisableScroll(this.handleScroll)

    Promise.all([
      require('../../../../lib/wrappers/lottieWrapper').getLottie(),
      fetch('https://static.nrk.no/dh/gfx/2019/sporten/vbm/lottie/vbm_tittel_final_m_tekst.json').then(res => res.json())
    ])
      .then(
        ([lottie, animationData]) => {
          if (this.fadingOut) {
            return
          }
          this.animationStarted = true

          this.animation = lottie.loadAnimation({
            container: this.animationElm, // the dom element that will contain the animation
            renderer: 'svg',
            loop: false,
            autoplay: false,
            animationData
          })
          this.animation.setSpeed(1.5)
          this.animation.addEventListener('complete', this.handleAnimationComplete)

          setTimeout(() => {
            this.elm.style.display = 'block'
            this.elm.style.opacity = '1'
            this.disableScroll.on()
            this.animation.goToAndPlay(0)
          }, 0)
        }
      )
  }

  componentDidUpdate (previousProps: Props) {
    if (!previousProps.complete && this.props.complete) {
      this.fadeOut()
    } else if (this.props.complete) {
      return
    }

    if (!previousProps.allowed && this.props.allowed) {
      // this.show()
    } else if (previousProps.allowed && !this.props.allowed) {
      this.fadeOut()
    }
  }

  handleScroll = () => {
    this.fadeOut()
  }

  fadeOut = () => {
    if (this.fadingOut) {
      return
    }

    this.fadingOut = true
    this.elm.style.opacity = '0'
    setTimeout(() => {
      this.elm.style.display = 'none'
      this.props.onComplete && this.props.onComplete()

      if (this.animation) {
        this.animation.destroy()
      }

      setTimeout(() => (this.disableScroll.off()), 300)
    }, 200)
  }

  handleAnimationComplete = () => {
    setTimeout(() => {
      this.fadeOut()
    }, 2000)
  }

  render () {
    return <div
      class={styles.logo2}
      ref={elm => (this.elm = elm)}>
      <div class={styles.logo2__box} />
      <div class={styles.logo2__image} ref={elm => (this.animationElm = elm)} />
    </div>
  }
}
